import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getWhiteLabelStatus = () => connectedStore.applySelector(selectors.getWhiteLabelStatus);

export default getWhiteLabelStatus;
